module.exports = __webpack_public_path__ + "static/media/icon_free_b.398cccd1.svg";